export var getCssVariable = function (cssVariable) {
    var computedStyle = window.getComputedStyle(document.documentElement);
    return computedStyle.getPropertyValue(cssVariable);
};
